import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
 deleteItem,
 fetchData,
 handleDragEnd,
 toggleStatus,
} from "../../../utils/apiUtils";
import {
 ActionButton,
 PlusButton,
 ToggleSwitch,
} from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import DeleteModel from "../../../Components/DeleteModel";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import debounce from "lodash.debounce";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../helper/Breadcrumb";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import dateformate from "../../../helper/DateFormate";
import BackButton from "../../../Components/BackButton";

const SubMenu = () => {
 const navigator = useNavigate();
 const location = useLocation();
 const editData = location.state;
 const [loading, setLoading] = useState(true);
 const [subMenuData, setsubMenuData] = useState([]);
 const [deleteItemId, setDeleteItemId] = useState({});
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const [IsDeleting, setIsDeleting] = useState(false);
 const totalPages = Math.ceil(totalCount / perPage);
 const [search, setSearch] = useState("");
 const [nextPosition, setNextPosition] = useState(0);

 const fetchsubMenuData = async (page = 1, searchQuery = "") => {
  const requestData = {
   perPage: perPage,
   pageNo: page,
   parentId: editData?.id,
   search: searchQuery,
  };
  await fetchData(
   "menu-pagination",
   requestData,
   setsubMenuData,
   setTotalCount,
   setCurrentPage,
   setLoading,
   setNextPosition
  );
 };
 const debouncedFetcCategory = useCallback(debounce(fetchsubMenuData, 1000), [
  perPage,
 ]);

 useEffect(() => {
  if (editData?.id) {
   debouncedFetcCategory(1, search);
  }
 }, [perPage, search]);

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalCount) {
   fetchsubMenuData(page);
  }
 };

 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("menu", deleteItemId?.id, fetchsubMenuData, []);
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (error) {
   return error;
  } finally {
   setIsDeleting(false);
  }
 };

 const handleEditClick = (item) => {
  navigator("/add-submenu", {
   state: item,
  });
 };

 const handleAdd = () => {
  navigator("/add-submenu", {
   state: {
    parentId: editData?.id,
    categoryId: editData?.categoryId || null,
    position: nextPosition,
   },
  });
 };

 const handleOnDragEnd = (result) => {
  handleDragEnd({
   result,
   data: subMenuData,
   setData: setsubMenuData,
   apiEndpoint: "/menu-position",
  });
 };

 const handleStatusToggle = async (item) => {
  const data = await toggleStatus("menu-status", item?.id);
  if (Object.keys(data).length > 0) {
   setsubMenuData((prevCategory) =>
    prevCategory.map((curr) =>
     curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };

 const Tableheader = ["Name", "Type",  "Updated At", "Is Active", "Action"];

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Menu", path: "/menu" },
  { label: "SubMenu", path: "/submenu" },
 ];

 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-5">
     <h3 className="custom-page-title">{editData?.label} Sub Menu</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-3"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
     <PerPageSelect value={perPage} onChange={setPerPage} />

     <div style={{ display: "flex", gap: "20px" }}>
        <BackButton/>
      <TableSearch value={search} onChange={setSearch} />
      <PlusButton handleAdd={handleAdd} module={"Sub Category"} />
     </div>
    </div>

    <div className="row" style={{ marginTop: "-10px" }}>
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <DragDropContext onDragEnd={handleOnDragEnd}>
         <Droppable droppableId="sliders">
          {(provided) => (
           <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="table-responsive"
           >
            <table
             className=" custom-table table table-striped"
             cellSpacing="0"
             id="subcategoryTable"
            >
             <thead>
              <tr>
               <th className="font-weight-bold col-1">Sort Order</th>
               {Tableheader.map((item, index) => (
                <th className="font-weight-bold" key={index}>
                 {item}
                </th>
               ))}
              </tr>
             </thead>

             <tbody>
              {loading ? (
               <tr>
                <td colSpan="12" className="text-center">
                 <Spinner />
                </td>
               </tr>
              ) : subMenuData?.length > 0 ? (
               subMenuData?.map((item, id) => {
                return (
                 <Draggable
                  key={item.id}
                  draggableId={item.id.toString()}
                  index={id}
                 >
                  {(provided) => (
                   <tr
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                   >
                    <td>{item.position}</td>
                    <td>{item?.label}</td>
                    <td>{item?.type}</td>
                    <td>{dateformate(item.updatedAt)}</td>
                    {/* <td>{dateformate(item.createdAt)}</td> */}

                    {/* <td>
                     {editData?.isMega ? (
                      <button
                       type="button"
                       className="count-button1"
                       onClick={() => navigator("/mega-menu", { state: item })}
                      >
                       {item._count?.children}
                      </button>
                     ) : (
                      <span>-</span>
                     )}
                    </td> */}

                    <td>
                     <ToggleSwitch
                      data={item}
                      name="isActive"
                      checked={item.isActive}
                      handleStatusToggle={handleStatusToggle}
                      module={"Menu"}
                     />
                    </td>
                    <td className="text-center">
                     <ActionButton
                      data={item}
                      handleEditClick={handleEditClick}
                      handleDelete={handleDelete}
                      module={"Menu"}
                     />
                    </td>
                   </tr>
                  )}
                 </Draggable>
                );
               })
              ) : (
               <tr>
                <td colSpan="12" className="text-center">
                 <h4>No data available</h4>
                </td>
               </tr>
              )}
             </tbody>
            </table>
           </div>
          )}
         </Droppable>
        </DragDropContext>

        {subMenuData.length > 0 && (
         <div style={{ marginTop: "30px" }}>
          <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
         </div>
        )}
       </div>
      </div>
     </div>
    </div>
   </div>

   {deleteModalOpen && (
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="sub Menu"
     IsDeleting={IsDeleting}
    />
   )}
  </>
 );
};

export default SubMenu;
